import { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import clsx from 'clsx';

const navLinks = [
  { to: '/', label: 'Anasayfa' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/hizmetler', label: 'Hizmetler' },
  { to: '/fiyatlandirma', label: 'Fiyatlandırma' },
  { to: '/iletisim', label: 'İletişim' },
  { to: '/blog', label: 'Blog' },
  { to: '/dokumantasyon', label: 'Dokümantasyon' },
];

export default function Header() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="w-full bg-white shadow-[0_2px_12px_0_rgba(0,0,0,0.04)] sticky top-0 z-50 border-b border-[var(--color-primary)]/30">
      <div className="max-w-[1920px] mx-auto flex items-center justify-between px-6 lg:px-12 py-4 min-h-[80px]">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 z-50" onClick={() => setMobileOpen(false)}>
          <img src="/logo.svg" alt="SolarTools Logo" className="h-16 w-auto" />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden lg:flex gap-6 xl:gap-10 flex-1 justify-center">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={clsx(
                'relative px-2 py-2 text-[var(--color-primary)] font-semibold text-base xl:text-lg tracking-wide transition-all duration-200 whitespace-nowrap',
                location.pathname === link.to
                  ? 'text-[var(--color-secondary)] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[5px] after:bg-[var(--color-secondary)] after:rounded-t'
                  : 'hover:text-[var(--color-secondary)]'
              )}
              style={{
                marginBottom: location.pathname === link.to ? '-18px' : '0',
              }}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Portal Girişi Butonu */}
        <div className="hidden lg:block">
          <button className="bg-[var(--color-primary)] text-white px-6 py-2.5 rounded-xl shadow-md hover:bg-[var(--color-secondary)] transition font-semibold text-base tracking-wide cursor-pointer whitespace-nowrap">
            Portal Girişi
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="lg:hidden flex items-center z-50">
          <button
            className="inline-flex items-center justify-center p-2 rounded-md text-[var(--color-primary)] hover:bg-[var(--color-secondary)] hover:text-white focus:outline-none"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menüyü Aç"
          >
            {mobileOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        <Transition
          show={mobileOpen}
          as={Fragment}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="lg:hidden fixed inset-0 bg-white z-40">
            <div className="flex flex-col items-center justify-center h-full">
              <nav className="flex flex-col items-center gap-6">
                {navLinks.map(link => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={clsx(
                      'text-xl font-semibold',
                      location.pathname === link.to
                        ? 'text-[var(--color-secondary)]'
                        : 'text-[var(--color-primary)] hover:text-[var(--color-secondary)]'
                    )}
                    onClick={() => setMobileOpen(false)}
                  >
                    {link.label}
                  </Link>
                ))}
                <button className="mt-4 bg-[var(--color-primary)] text-white px-6 py-2.5 rounded-xl shadow-md hover:bg-[var(--color-secondary)] transition font-semibold text-base tracking-wide cursor-pointer">
                  Portal Girişi
                </button>
              </nav>
            </div>
          </div>
        </Transition>
      </div>
    </header>
  );
} 